import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CareerSurveyStore {
  private _surveyTaken = signal<boolean>(false);
  readonly careerSurveyTaken = this._surveyTaken.asReadonly();

  setCareerSurveyTaken() {
    this._surveyTaken.set(true);
  }

  resetSurveyTaken() {
    this._surveyTaken.set(false);
  }
}
